function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_78",
  "data-name": "Path 78",
  d: "M4517.9,77.2c-.082,0-.149.047-.149.1V87.6c0,.058.067.105.149.105h5.125c.079,0,.145.045.147.1s.005.1.005.152c0,2.235-2.126,4.117-5.023,4.685-.064.012-.109.054-.109.1v4.535c0,.057.064.1.146.1h0c7.7,0,13.982-4.287,14.365-9.678h.018V77.3c0-.058-.066-.1-.149-.1Z",
  transform: "translate(-4517.004 -76.448)",
  fill: "none",
  stroke: "#f65e5c",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
});

var SvgCommaIcon = function SvgCommaIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.323,
    height: 21.689,
    viewBox: "0 0 16.323 21.689",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCommaIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/comma-icon.16c852db.svg";
export { ForwardRef as ReactComponent };